// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "container-iCohc";
var _5 = "wrapper-3QMe9";
var _6 = "title-TToSe";
var _7 = "form-20N_u";
var _8 = "search-2GfPp";
var _9 = "locations-1BuRw";
var _a = "location-Wf9m7";
var _b = "input-1ufeL";
var _c = "button-3ncl9";
var _d = "buttonSwitch-1UJt8";
var _e = "filters-IjO6f";
var _f = "from-GIahg";
var _10 = "to-ttmOq";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "container", _5 as "wrapper", _6 as "title", _7 as "form", _8 as "search", _9 as "locations", _a as "location", _b as "input", _c as "button", _d as "buttonSwitch", _e as "filters", _f as "from", _10 as "to" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "container": _4, "wrapper": _5, "title": _6, "form": _7, "search": _8, "locations": _9, "location": _a, "input": _b, "button": _c, "buttonSwitch": _d, "filters": _e, "from": _f, "to": _10 }
